import type { GetStaticProps } from 'next'
import ImageBanner from '@components/ImageBanner'
import type { pageTitle, pageContent } from '@lib/types'
import { CarouselBasic } from '@components/Carousels'
import { getPageTitleContentFromDB, getPageContentFromDB } from '@lib/pagequerys'
import { Container, Heading, LinkComponent, Section, Text } from '@components/SectionComponents'


export const getStaticProps: GetStaticProps = async () => {

    // page_id in DB
    const pageIdDB: number = 12;

    // query DB for page title data
    const pageTitle: pageTitle = await getPageTitleContentFromDB(pageIdDB);

    // Array of pageContent - query DB for pageContent data
    const pageContent: pageContent[] = await getPageContentFromDB(pageIdDB);

    return {
        props: {
            pageTitle,
            pageContent,
        }
    }
}

// Home Page takes a pageTitle, and pageContent array
export default function Page({ pageTitle, pageContent }: {
    pageTitle: pageTitle,
    pageContent: pageContent[],
}) {

    return <>

        <ImageBanner title={pageTitle} />

        {/* Offers section temperarily commented out until further notice 
      
      Section 0 
      <section className={`${styles.section} ${styles.sectionShort} ${styles.sectionBrown}`}>
          <div className={`${styles.container}`}>
              <h1  dangerouslySetInnerHTML={{__html: pageContent[0].title!}}></h1>
              <p dangerouslySetInnerHTML={{__html: pageContent[0].text!}}></p>
          </div>
          <CarouselBasic images={pageContent[0].carouselImages !} extraClass={`${styles.carouselSmallBottomDesktop} ${styles.carouselSmallBottomMobile}`}/>
      </section>    */}

        {/* Section 1 */}
        <Section id='australiazoo' colour='white'>
            <Container longer='bottom'>
                <Heading h1={true} content={{ title: pageContent[1].title }} />
                <Text content={pageContent[1].text} />
                <LinkComponent link1={pageContent[1].link1} />
            </Container>
        </Section>

        {/* Section 2 */}
        <Section colour='cream'>
            <CarouselBasic images={pageContent[2].carouselImages} overlap='top'/>
            <Container longer="both">
                <Heading content={{
                    title: pageContent[2].title,
                    subtitle: pageContent[2].subtitle
                }} />
                <Text content={pageContent[2].text} />
                <LinkComponent
                    link1={pageContent[2].link1}
                    link2={pageContent[2].link2}
                />
            </Container>
        </Section>

        {/* Section 3 */}
        <Section id="hospital" colour="brown">
            <CarouselBasic images={pageContent[3].carouselImages} overlap='top' />
            <Container longer="both">
                <Heading content={{ title: pageContent[3].title }} />
                <Text content={pageContent[3].text} />
                <LinkComponent
                    link1={pageContent[3].link1}
                    link2={pageContent[3].link2}
                />
            </Container>
        </Section>

        {/* Section 4 */}
        <Section colour='white'>
        <CarouselBasic images={pageContent[4].carouselImages} overlap='top' />
            <Container longer="top">
                <Heading content={{ title: pageContent[4].title }} />
                <Text content={pageContent[4].text} />
                <LinkComponent link1={pageContent[4].link1} />
            </Container>
        </Section>

    </>
}
//Meta Data
Page.title = "Experiences";
Page.description = "Crikey! No trip to The Crocodile Hunter Lodge is complete without a trip to Australia Zoo. Steve and Terri grew the roadside park into the famed zoological gardens here today.";
